import { TargetValueType } from "../containers/ReportPanels/CompareValuePanel";

import StressSelectPrimary from "./stress_report_select.json";
import StressSelectSecondary from "./stress_report_select_1.json";

import CounselingSelectPrimary from "./counseling_report_select.json";
import CounselingSelectSecondary from "./counseling_report_select_1.json";

import IndividualPrimary from "./individual_user.json";
import IndividualSecondary from "./individual_user_1.json";

export const StressTestMockup = {
	[TargetValueType.Primary]: StressSelectPrimary,
	[TargetValueType.Secondary]: StressSelectSecondary 
};
export const CounselingMockup = {
	[TargetValueType.Primary]: CounselingSelectPrimary,
	[TargetValueType.Secondary]: CounselingSelectSecondary 
};
export const IndividualUserMockup = {
	[TargetValueType.Primary]: IndividualPrimary,
	[TargetValueType.Secondary]: IndividualSecondary,
};


// WEBPACK FOOTER //
// ./src/_mockup/index.js